import { createRouter, createWebHistory } from "vue-router";
import { useUserStore } from "@/stores/user";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", redirect: () => routeAfterAuthRedirect() },
    { path: "/welcome", component: () => import("@/views/WelcomeView.vue"), meta: { anonymous: true } },
    { path: "/onboarding", component: () => import("@/views/OnboardingView.vue"), meta: { anonymous: true } },
    { path: "/select-state", component: () => import("@/views/StateSelectView.vue"), meta: { anonymous: true } },
    { path: "/capture", component: () => import("@/views/EmailCaptureView.vue"), meta: { anonymous: true } },
    { path: "/downloading", component: () => import("@/views/PackDownloadingView.vue") },
    { path: "/orientation", component: () => import("@/views/OrientationView.vue") },
    { path: "/home", component: () => import("@/views/HomeView.vue") },
    { path: "/section/:sectionId", component: () => import("@/views/SectionView.vue") },
    { path: "/section/:sectionId/read", component: () => import("@/views/ReadView.vue") },
    { path: "/section/:sectionId/flashcards", component: () => import("@/views/FlashcardView.vue") },
    { path: "/section/:sectionId/quiz", component: () => import("@/views/QuizView.vue") },
    { path: "/section/:sectionId/quiz/results", component: () => import("@/views/QuizResultsView.vue") },
    { path: "/mock-exam", component: () => import("@/views/MockExamView.vue") },
    { path: "/mock-exam/results", component: () => import("@/views/MockExamResultsView.vue") },
    { path: "/weak-areas", component: () => import("@/views/WeakAreaView.vue") },
    { path: "/badges", component: () => import("@/views/BadgesView.vue") },
    { path: "/contact", component: () => import("@/views/ContactView.vue") },
    { path: "/enroll", component: () => import("@/views/EnrollmentView.vue") },
    { path: "/settings", component: () => import("@/views/SettingsView.vue") },
    { path: "/admin", component: () => import("@/views/AdminView.vue"), meta: { anonymous: true } },
    { path: "/terms", component: () => import("@/views/TermsView.vue"), meta: { anonymous: true } },
    { path: "/privacy", component: () => import("@/views/PrivacyView.vue"), meta: { anonymous: true } },
    { path: "/account-deletion", component: () => import("@/views/AccountDeletionView.vue"), meta: { anonymous: true } }
  ]
});

function routeAfterAuthRedirect() {
  const user = useUserStore();
  return user.isAuthenticated ? "/home" : "/welcome";
}

router.beforeEach((to) => {
  const user = useUserStore();
  if (to.meta.anonymous) return true;
  if (!user.isAuthenticated) return "/welcome";
  if (!user.hasSeenOrientation && to.path !== "/orientation" && to.path !== "/downloading") {
    return "/orientation";
  }
  return true;
});

export default router;
